module.exports = __webpack_public_path__ + "img/root folder.4c7c1a3c.svg";